import React from 'react'

const PrivacyPolicy = () => {
    return (
        <div className="px-8 py-10 mt-20 font-basefont">
            <h1 className="text-4xl text-center font-semibold mb-4 border-b pb-4">
                Privacy Policy Overview
            </h1>

            <div className="max-w-4xl mx-auto mt-8 space-y-6 text-lg leading-relaxed text-gray-800">

                <p>
                    This Privacy Policy describes how PG Overseas Services ("we," "us," or "our") collects,
                    uses, and discloses information that we obtain about visitors to our website, users of our
                    services, and other individuals with whom we interact. We are committed to protecting
                    the privacy of your personal information. By visiting our website or using our services,
                    you agree to the collection and use of information in accordance with this policy.
                </p>

                <div className="space-y-6">
                    <div>
                        <h3 className="text-xl font-semibold">1. Information We Collect</h3>
                        <ul className="list-disc list-inside mt-2 space-y-2">
                            <li><strong>Personal Identification Information:</strong> Name, date of birth, gender, nationality, passport details, visa information, etc.</li>
                            <li><strong>Contact Information:</strong> Email, phone, address.</li>
                            <li><strong>Educational Information:</strong> Transcripts, degrees, etc.</li>
                            <li><strong>Employment Information:</strong> Resume, job history, references.</li>
                            <li><strong>Financial Information:</strong> Bank statements, tax records.</li>
                            <li><strong>Health Information:</strong> Medical reports, vaccinations.</li>
                            <li><strong>Family Information:</strong> Dependents, marital status.</li>
                            <li><strong>Usage Data:</strong> IP, browser, visit times.</li>
                            <li><strong>Cookies:</strong> We use cookies and tracking tools to improve experience.</li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xl font-semibold">2. How We Collect Information</h3>
                        <ul className="list-disc list-inside mt-2">
                            <li>Through forms and direct interactions</li>
                            <li>From third parties authorized by you</li>
                            <li>Automatically via website analytics</li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xl font-semibold">3. How We Use Your Information</h3>
                        <ul className="list-disc list-inside mt-2 space-y-1">
                            <li>To facilitate our services (visa, education, job placement)</li>
                            <li>To communicate with you and provide support</li>
                            <li>To process payments and improve services</li>
                            <li>To fulfill legal obligations and prevent fraud</li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xl font-semibold">4. Sharing and Disclosure</h3>
                        <ul className="list-disc list-inside mt-2">
                            <li><strong>With authorities</strong> (e.g., embassies, employers)</li>
                            <li><strong>With service providers</strong> (e.g., payment, courier)</li>
                            <li><strong>For legal requirements</strong> or in business transfers</li>
                            <li><strong>With your explicit consent</strong></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xl font-semibold">5. Data Security</h3>
                        <p>
                            We implement security measures to protect your data, but cannot guarantee absolute safety of electronic storage or transmission.
                        </p>
                    </div>

                    <div>
                        <h3 className="text-xl font-semibold">6. Data Retention</h3>
                        <p>
                            Your data will be retained as long as necessary for service delivery, legal compliance, or dispute resolution.
                        </p>
                    </div>

                    <div>
                        <h3 className="text-xl font-semibold">7. International Data Transfers</h3>
                        <p>
                            Your data may be processed outside your region. By using our service, you agree to this transfer with appropriate safeguards.
                        </p>
                    </div>

                    <div>
                        <h3 className="text-xl font-semibold">8. Your Data Protection Rights</h3>
                        <ul className="list-disc list-inside mt-2 space-y-1">
                            <li>Right to access, rectify, erase, restrict, object, and port data</li>
                            <li>We respond within one month to data requests</li>
                            <li>Email us to exercise your rights: <em>[Insert Your Contact Email]</em></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xl font-semibold">9. Third-Party Links</h3>
                        <p>
                            We are not responsible for the privacy practices of third-party websites linked from ours.
                        </p>
                    </div>

                    <div>
                        <h3 className="text-xl font-semibold">10. Children's Privacy</h3>
                        <p>
                            We do not knowingly collect data from users under 18. Parents may contact us if they believe a minor has submitted data.
                        </p>
                    </div>

                    <div>
                        <h3 className="text-xl font-semibold">11. Changes to This Policy</h3>
                        <p>
                            We may update this policy and will notify you via website or email. Please review it periodically.
                        </p>
                    </div>

                    <div>
                        <h3 className="text-xl font-semibold">12. Contact Us</h3>
                        <ul className="list-disc list-inside mt-2">
                            <li>Visit: <a href="https://www.pgoverseasservices.com/contact" className="text-blue-600 underline">Contact Page</a></li>
                            <li>Phone: +91 9925000431</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default PrivacyPolicy